// extracted by mini-css-extract-plugin
export default {"spanRequired":"KgxIjULYn5LroWvZCo6Q"};